// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import SidebarTouchController from "./sidebar_touch_controller"
application.register("sidebar-touch", SidebarTouchController)
import NavigationTriggerController from "./navigation_trigger_controller"
application.register("navigation-trigger", NavigationTriggerController)
import CoreNavMenuController from "./core_nav_menu_controller"
application.register("core-nav-menu", CoreNavMenuController)
import EditNavigationController from "./edit_navigation_controller"
application.register("edit-navigation", EditNavigationController)

import PersonaVideoSettingsController from "./persona_video_settings_controller"
application.register("persona-video-settings", PersonaVideoSettingsController)

import BirthdayRowsController from "./birthday_rows_controller"
application.register("birthday-rows", BirthdayRowsController)

import AvatarAppearanceController from "./avatar_appearance_controller"
application.register("avatar-appearance", AvatarAppearanceController)

import AvatarGenerationController from "./avatar_generation_controller"
application.register("avatar-generation", AvatarGenerationController)

import AccountMenuController from "./account_menu_controller"
application.register("account-menu", AccountMenuController)

import ActivitySeenController from "./activity_seen_controller"
application.register("activity-seen", ActivitySeenController)

import ActivitySwipeController from "./activity_swipe_controller"
application.register("activity-swipe", ActivitySwipeController)

import AddPinController from "./add_pin_controller"
application.register("add-pin", AddPinController)

import AppCardLinkController from "./app_card_link_controller"
application.register("app-card-link", AppCardLinkController)

import AppSettingsMenuController from "./app_settings_menu_controller"
application.register("app-settings-menu", AppSettingsMenuController)

import AppsLibraryController from "./apps_library_controller"
application.register("apps-library", AppsLibraryController)

import ArchiveBatchController from "./archive_batch_controller"
application.register("archive-batch", ArchiveBatchController)

import ArchiveSortController from "./archive_sort_controller"
application.register("archive-sort", ArchiveSortController)

import AskCardController from "./ask_card_controller"
application.register("ask-card", AskCardController)

import AssistantComposeController from "./assistant_compose_controller"
application.register("assistant-compose", AssistantComposeController)

import AssistantHeroController from "./assistant_hero_controller"
application.register("assistant-hero", AssistantHeroController)

import AssistantLocalTimeController from "./assistant_local_time_controller"
application.register("assistant-local-time", AssistantLocalTimeController)

import AssistantPollController from "./assistant_poll_controller"
application.register("assistant-poll", AssistantPollController)

import AssistantSpeakController from "./assistant_speak_controller"
application.register("assistant-speak", AssistantSpeakController)
import MessageActionsController from "./message_actions_controller"
application.register("message-actions", MessageActionsController)

import AssistantVoiceController from "./assistant_voice_controller"
application.register("assistant-voice", AssistantVoiceController)


import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)
import ClickupPanelController from "./clickup_panel_controller"
application.register("clickup-panel", ClickupPanelController)

import AutomationFormController from "./automation_form_controller"
application.register("automation-form", AutomationFormController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import AvatarImageController from "./avatar_image_controller"
application.register("avatar-image", AvatarImageController)

import BackgroundCycleController from "./background_cycle_controller"
application.register("background-cycle", BackgroundCycleController)

import CardPagerController from "./card_pager_controller"
application.register("card-pager", CardPagerController)

import CardStackController from "./card_stack_controller"
application.register("card-stack", CardStackController)

import CategoryPickerController from "./category_picker_controller"
application.register("category-picker", CategoryPickerController)

import CelebrationController from "./celebration_controller"
application.register("celebration", CelebrationController)

import ChatHistoryController from "./chat_history_controller"
application.register("chat-history", ChatHistoryController)

import ChatReactionsController from "./chat_reactions_controller"
application.register("chat-reactions", ChatReactionsController)

import ChipOverflowController from "./chip_overflow_controller"
application.register("chip-overflow", ChipOverflowController)

import CommunityChatController from "./community_chat_controller"
application.register("community-chat", CommunityChatController)

import CommunityChatPanelController from "./community_chat_panel_controller"
application.register("community-chat-panel", CommunityChatPanelController)

import CommunityCityController from "./community_city_controller"
application.register("community-city", CommunityCityController)

import CommunityImmersiveController from "./community_immersive_controller"
application.register("community-immersive", CommunityImmersiveController)

import CommunityLocationController from "./community_location_controller"
application.register("community-location", CommunityLocationController)

import CommunitySquareController from "./community_square_controller"
application.register("community-square", CommunitySquareController)

import CompanyUnlinkController from "./company_unlink_controller"
application.register("company-unlink", CompanyUnlinkController)

import OutgoingDraftController from "./outgoing_draft_controller"
application.register("outgoing-draft", OutgoingDraftController)

import ComposerDestinationController from "./composer_destination_controller"
application.register("composer-destination", ComposerDestinationController)

import ComposerSubmitController from "./composer_submit_controller"
application.register("composer-submit", ComposerSubmitController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ContactAddController from "./contact_add_controller"
application.register("contact-add", ContactAddController)

import ContactConnectionsController from "./contact_connections_controller"
application.register("contact-connections", ContactConnectionsController)

import ContactDetailMenuController from "./contact_detail_menu_controller"
application.register("contact-detail-menu", ContactDetailMenuController)

import ContactEditController from "./contact_edit_controller"
application.register("contact-edit", ContactEditController)

import ContactFoldController from "./contact_fold_controller"
application.register("contact-fold", ContactFoldController)
import CardAlertController from "./card_alert_controller"
application.register("card-alert", CardAlertController)
import FoldSectionController from "./fold_section_controller"
application.register("fold-section", FoldSectionController)
import ContactReachController from "./contact_reach_controller"
application.register("contact-reach", ContactReachController)
import ContactMessageController from "./contact_message_controller"
application.register("contact-message", ContactMessageController)

import ContactGroupsController from "./contact_groups_controller"
application.register("contact-groups", ContactGroupsController)

import ContactPickerController from "./contact_picker_controller"
application.register("contact-picker", ContactPickerController)

import ContactRenameController from "./contact_rename_controller"
application.register("contact-rename", ContactRenameController)

import ContactRowMenuController from "./contact_row_menu_controller"
application.register("contact-row-menu", ContactRowMenuController)

import ContactTreeController from "./contact_tree_controller"
application.register("contact-tree", ContactTreeController)

import ContactViewController from "./contact_view_controller"
application.register("contact-view", ContactViewController)

import CopyTextController from "./copy_text_controller"
application.register("copy-text", CopyTextController)

import CountryCompaniesController from "./country_companies_controller"
application.register("country-companies", CountryCompaniesController)

import CountryPickerController from "./country_picker_controller"
application.register("country-picker", CountryPickerController)

import DailyCardController from "./daily_card_controller"
application.register("daily-card", DailyCardController)


import DashboardPickerController from "./dashboard_picker_controller"
application.register("dashboard-picker", DashboardPickerController)

import DatingProfilePanelController from "./dating_profile_panel_controller"
application.register("dating-profile-panel", DatingProfilePanelController)

import DatingSwipeController from "./dating_swipe_controller"
application.register("dating-swipe", DatingSwipeController)

import DemoContactGroupsController from "./demo_contact_groups_controller"
application.register("demo-contact-groups", DemoContactGroupsController)

import DemoTasksOutlineController from "./demo_tasks_outline_controller"
application.register("demo-tasks-outline", DemoTasksOutlineController)

import DetailModalController from "./detail_modal_controller"
application.register("detail-modal", DetailModalController)

import DialChartController from "./dial_chart_controller"
application.register("dial-chart", DialChartController)

import DialsBoardController from "./dials_board_controller"
application.register("dials-board", DialsBoardController)

import DialsFormController from "./dials_form_controller"
application.register("dials-form", DialsFormController)

import DialsRenameController from "./dials_rename_controller"
application.register("dials-rename", DialsRenameController)

import DisableOnSubmitController from "./disable_on_submit_controller"
application.register("disable-on-submit", DisableOnSubmitController)

import DictationController from "./dictation_controller"
application.register("dictation", DictationController)

import DmComposeController from "./dm_compose_controller"
application.register("dm-compose", DmComposeController)

import DocsMarkdownEditorController from "./docs_markdown_editor_controller"
import PlaybookCollabController from "./playbook_collab_controller"
import TaskListPaneController from "./task_list_pane_controller"
import PanelLinkController from "./panel_link_controller"
application.register("docs-markdown-editor", DocsMarkdownEditorController)
application.register("playbook-collab", PlaybookCollabController)
application.register("task-list-pane", TaskListPaneController)
application.register("panel-link", PanelLinkController)

import DocsRailController from "./docs_rail_controller"
application.register("docs-rail", DocsRailController)

import DraftReviewController from "./draft_review_controller"
application.register("draft-review", DraftReviewController)

import DuetLinesController from "./duet_lines_controller"
application.register("duet-lines", DuetLinesController)

import DuetStageController from "./duet_stage_controller"
application.register("duet-stage", DuetStageController)

import MemoryGradeController from "./memory_grade_controller"
application.register("memory-grade", MemoryGradeController)

import MemoryTimelineController from "./memory_timeline_controller"
application.register("memory-timeline", MemoryTimelineController)

import DuplicateReviewController from "./duplicate_review_controller"
application.register("duplicate-review", DuplicateReviewController)

import EditPinController from "./edit_pin_controller"
application.register("edit-pin", EditPinController)

import EmailBodyController from "./email_body_controller"
application.register("email-body", EmailBodyController)

import EventCardController from "./event_card_controller"
application.register("event-card", EventCardController)


import EmailModalController from "./email_modal_controller"
application.register("email-modal", EmailModalController)

import EmojiFieldController from "./emoji_field_controller"
application.register("emoji-field", EmojiFieldController)

import EmojiPickerController from "./emoji_picker_controller"
application.register("emoji-picker", EmojiPickerController)

import ElektQueueController from "./elekt_queue_controller"
application.register("elekt-queue", ElektQueueController)

import EventDetailController from "./event_detail_controller"
application.register("event-detail", EventDetailController)

import FamilyPersonPanelController from "./family_person_panel_controller"
application.register("family-person-panel", FamilyPersonPanelController)

import FamilyTreeHintsController from "./family_tree_hints_controller"
application.register("family-tree-hints", FamilyTreeHintsController)

import FamilyTreeSharePickerController from "./family_tree_share_picker_controller"
application.register("family-tree-share-picker", FamilyTreeSharePickerController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FilesAppController from "./files_app_controller"
application.register("files-app", FilesAppController)
import JaneAvatarController from "./jane_avatar_controller"
application.register("jane-avatar", JaneAvatarController)
import JaneKeepController from "./jane_keep_controller"
application.register("jane-keep", JaneKeepController)
import PostCardController from "./post_card_controller"
application.register("post-card", PostCardController)

import SelectTextController from "./select_text_controller"
application.register("select-text", SelectTextController)

import SidebarViewsController from "./sidebar_views_controller"
application.register("sidebar-views", SidebarViewsController)

import MessageSelectController from "./message_select_controller"
application.register("message-select", MessageSelectController)

import TwinPhotoController from "./twin_photo_controller"
application.register("twin-photo", TwinPhotoController)
import TwinVoiceController from "./twin_voice_controller"
application.register("twin-voice", TwinVoiceController)
import ProfileStageController from "./profile_stage_controller"
application.register("profile-stage", ProfileStageController)
import ProfileMessagesController from "./profile_messages_controller"
application.register("profile-messages", ProfileMessagesController)
import ProfileChatPanelController from "./profile_chat_panel_controller"
application.register("profile-chat-panel", ProfileChatPanelController)
import AnswerOrderController from "./answer_order_controller"
application.register("answer-order", AnswerOrderController)

import PageRefreshController from "./page_refresh_controller"
application.register("page-refresh", PageRefreshController)

import LipsyncToggleController from "./lipsync_toggle_controller"
application.register("lipsync-toggle", LipsyncToggleController)

import DubRecorderController from "./dub_recorder_controller"
application.register("dub-recorder", DubRecorderController)

import VoiceRecorderController from "./voice_recorder_controller"
application.register("voice-recorder", VoiceRecorderController)

import AnswerDraftController from "./answer_draft_controller"
application.register("answer-draft", AnswerDraftController)
import FindTimeController from "./find_time_controller"
application.register("find-time", FindTimeController)

import FrameRefreshController from "./frame_refresh_controller"
application.register("frame-refresh", FrameRefreshController)
import GallerySelectController from "./gallery_select_controller"
application.register("gallery-select", GallerySelectController)

import FilesRowController from "./files_row_controller"
application.register("files-row", FilesRowController)

import FilesSearchController from "./files_search_controller"
application.register("files-search", FilesSearchController)

import FilesTagsController from "./files_tags_controller"
application.register("files-tags", FilesTagsController)

import FolderManageController from "./folder_manage_controller"
application.register("folder-manage", FolderManageController)

import HashNavController from "./hash_nav_controller"
application.register("hash-nav", HashNavController)

import HideOnErrorController from "./hide_on_error_controller"
application.register("hide-on-error", HideOnErrorController)

import HistoryGroupsController from "./history_groups_controller"
application.register("history-groups", HistoryGroupsController)

import HomeIconPickerController from "./home_icon_picker_controller"
application.register("home-icon-picker", HomeIconPickerController)

import HomeSettingsController from "./home_settings_controller"
application.register("home-settings", HomeSettingsController)

import HomeDesktopController from "./home_desktop_controller"
application.register("home-desktop", HomeDesktopController)

import InlineRenameController from "./inline_rename_controller"
application.register("inline-rename", InlineRenameController)

import PinnedListController from "./pinned_list_controller"
application.register("pinned-list", PinnedListController)
import QuickActionPickerController from "./quick_action_picker_controller"
application.register("quick-action-picker", QuickActionPickerController)
import QuickActionFillController from "./quick_action_fill_controller"
application.register("quick-action-fill", QuickActionFillController)
import DashboardRailReorderController from "./dashboard_rail_reorder_controller"
application.register("dashboard-rail-reorder", DashboardRailReorderController)

import PinsDialogController from "./pins_dialog_controller"
application.register("pins-dialog", PinsDialogController)

import WidgetStackController from "./widget_stack_controller"
application.register("widget-stack", WidgetStackController)

import HomeTaskCheckController from "./home_task_check_controller"
application.register("home-task-check", HomeTaskCheckController)

import DialClockController from "./dial_clock_controller"
application.register("dial-clock", DialClockController)

import ImageLightboxController from "./image_lightbox_controller"
application.register("image-lightbox", ImageLightboxController)

import ImageProviderController from "./image_provider_controller"
application.register("image-provider", ImageProviderController)

import ImpersonationBannerController from "./impersonation_banner_controller"
application.register("impersonation-banner", ImpersonationBannerController)

import InertLinksController from "./inert_links_controller"
application.register("inert-links", InertLinksController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import IntentInvariantController from "./intent_invariant_controller"
application.register("intent-invariant", IntentInvariantController)


import InvitePreviewController from "./invite_preview_controller"
application.register("invite-preview", InvitePreviewController)

import JanePanelController from "./jane_panel_controller"
application.register("jane-panel", JanePanelController)

import JaneSidebarController from "./jane_sidebar_controller"
application.register("jane-sidebar", JaneSidebarController)

import JaneSidebarToggleController from "./jane_sidebar_toggle_controller"
application.register("jane-sidebar-toggle", JaneSidebarToggleController)



import LinkedinRefreshController from "./linkedin_refresh_controller"
application.register("linkedin-refresh", LinkedinRefreshController)

import ListSwitcherController from "./list_switcher_controller"
application.register("list-switcher", ListSwitcherController)

import LocationTypeaheadController from "./location_typeahead_controller"
application.register("location-typeahead", LocationTypeaheadController)

import MemoriesController from "./memories_controller"
application.register("memories", MemoriesController)

import MenuFilterController from "./menu_filter_controller"
application.register("menu-filter", MenuFilterController)
import PlaybookOwnerPickerController from "./playbook_owner_picker_controller"
application.register("playbook-owner-picker", PlaybookOwnerPickerController)
import MemberDetailsController from "./member_details_controller"
application.register("member-details", MemberDetailsController)
import PlaybookProcessesController from "./playbook_processes_controller"
application.register("playbook-processes", PlaybookProcessesController)
import PlaybookDutyPaneController from "./playbook_duty_pane_controller"
application.register("playbook-duty-pane", PlaybookDutyPaneController)
import PlaybookDutyLinkController from "./playbook_duty_link_controller"
application.register("playbook-duty-link", PlaybookDutyLinkController)

import MessageAttachController from "./message_attach_controller"
application.register("message-attach", MessageAttachController)

import MessagesSidebarController from "./messages_sidebar_controller"
application.register("messages-sidebar", MessagesSidebarController)

import MilestoneToastController from "./milestone_toast_controller"
application.register("milestone-toast", MilestoneToastController)

import ModalOpenerController from "./modal_opener_controller"
application.register("modal-opener", ModalOpenerController)

import MoreRowsController from "./more_rows_controller"
application.register("more-rows", MoreRowsController)

import MsgDetailActionsController from "./msg_detail_actions_controller"
application.register("msg-detail-actions", MsgDetailActionsController)

import MsgDetailController from "./msg_detail_controller"
application.register("msg-detail", MsgDetailController)

import EngagedPeopleController from "./engaged_people_controller"
application.register("engaged-people", EngagedPeopleController)

import StudioComposerController from "./studio_composer_controller"
application.register("studio-composer", StudioComposerController)
import StudioMentionsController from "./studio_mentions_controller"
application.register("studio-mentions", StudioMentionsController)

import NativeKeyboardController from "./native_keyboard_controller"
application.register("native-keyboard", NativeKeyboardController)

import NativePushController from "./native_push_controller"
application.register("native-push", NativePushController)

import NativePushPromptController from "./native_push_prompt_controller"
application.register("native-push-prompt", NativePushPromptController)

import RailAppMenuController from "./rail_app_menu_controller"
application.register("rail-app-menu", RailAppMenuController)

import RailChatsController from "./rail_chats_controller"
application.register("rail-chats", RailChatsController)

import RailResizeController from "./rail_resize_controller"
application.register("rail-resize", RailResizeController)

import NavAppsController from "./nav_apps_controller"
application.register("nav-apps", NavAppsController)

import NavMoreController from "./nav_more_controller"
application.register("nav-more", NavMoreController)

import CoreNavMoreController from "./core_nav_more_controller"
application.register("core-nav-more", CoreNavMoreController)

import NavReorderController from "./nav_reorder_controller"
application.register("nav-reorder", NavReorderController)
import CalendarDrawerReorderController from "./calendar_drawer_reorder_controller"
application.register("calendar-drawer-reorder", CalendarDrawerReorderController)
import PlaybookReorderController from "./playbook_reorder_controller"
application.register("playbook-reorder", PlaybookReorderController)

import NetworkMapController from "./network_map_controller"
application.register("network-map", NetworkMapController)
import NetworkSegmentsController from "./network_segments_controller"
application.register("network-segments", NetworkSegmentsController)

import NewFolderController from "./new_folder_controller"
application.register("new-folder", NewFolderController)

import NoteSidebarController from "./note_sidebar_controller"
application.register("note-sidebar", NoteSidebarController)

import OnboardingIntroController from "./onboarding_intro_controller"
application.register("onboarding-intro", OnboardingIntroController)

import OrgChartPollController from "./org_chart_poll_controller"
application.register("org-chart-poll", OrgChartPollController)

import PeerChatController from "./peer_chat_controller"
application.register("peer-chat", PeerChatController)

import PersonaHeroPhotosController from "./persona_hero_photos_controller"
application.register("persona-hero-photos", PersonaHeroPhotosController)

import PersonaMediaController from "./persona_media_controller"
application.register("persona-media", PersonaMediaController)


import PersonaPortraitActionsController from "./persona_portrait_actions_controller"
application.register("persona-portrait-actions", PersonaPortraitActionsController)

import PersonaPortraitsController from "./persona_portraits_controller"
application.register("persona-portraits", PersonaPortraitsController)

import PersonaSheetController from "./persona_sheet_controller"
application.register("persona-sheet", PersonaSheetController)

import PersonaVoiceController from "./persona_voice_controller"
application.register("persona-voice", PersonaVoiceController)

import PinController from "./pin_controller"
application.register("pin", PinController)

import PinFolderController from "./pin_folder_controller"
application.register("pin-folder", PinFolderController)

import PinMenuController from "./pin_menu_controller"
application.register("pin-menu", PinMenuController)

import PinRemoveController from "./pin_remove_controller"
application.register("pin-remove", PinRemoveController)

import PinReorderController from "./pin_reorder_controller"
application.register("pin-reorder", PinReorderController)

import PipelineBoardController from "./pipeline_board_controller"
application.register("pipeline-board", PipelineBoardController)



import PresenceController from "./presence_controller"
application.register("presence", PresenceController)

import ProfileAudienceController from "./profile_audience_controller"
application.register("profile-audience", ProfileAudienceController)



import ProfileSectionController from "./profile_section_controller"
application.register("profile-section", ProfileSectionController)

import PublicTasksController from "./public_tasks_controller"
application.register("public-tasks", PublicTasksController)

import PushController from "./push_controller"
application.register("push", PushController)

import PushPromptController from "./push_prompt_controller"
application.register("push-prompt", PushPromptController)


import RailTipController from "./rail_tip_controller"
application.register("rail-tip", RailTipController)

import ReflectionComposerController from "./reflection_composer_controller"
application.register("reflection-composer", ReflectionComposerController)

import ReflectionFeedController from "./reflection_feed_controller"
application.register("reflection-feed", ReflectionFeedController)

import RelationshipFormController from "./relationship_form_controller"
application.register("relationship-form", RelationshipFormController)

import RelationshipReviewController from "./relationship_review_controller"
application.register("relationship-review", RelationshipReviewController)

import ResumePrintController from "./resume_print_controller"
application.register("resume-print", ResumePrintController)

import RowSwipeController from "./row_swipe_controller"
application.register("row-swipe", RowSwipeController)

import SetupPollController from "./setup_poll_controller"
application.register("setup-poll", SetupPollController)

import ShareLinkController from "./share_link_controller"
application.register("share-link", ShareLinkController)
import TaskListIndexController from "./task_list_index_controller"
application.register("task-list-index", TaskListIndexController)
import SharePickerController from "./share_picker_controller"
application.register("share-picker", SharePickerController)

import SidebarCollapseController from "./sidebar_collapse_controller"
application.register("sidebar-collapse", SidebarCollapseController)

import SplitMenuController from "./split_menu_controller"
application.register("split-menu", SplitMenuController)

import StepperController from "./stepper_controller"
application.register("stepper", StepperController)

import SuggestionReviewController from "./suggestion_review_controller"
application.register("suggestion-review", SuggestionReviewController)

import SystemToastController from "./system_toast_controller"
application.register("system-toast", SystemToastController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TwinNoteFormController from "./twin_note_form_controller"
application.register("twin-note-form", TwinNoteFormController)


import TaskListMenuController from "./task_list_menu_controller"
application.register("task-list-menu", TaskListMenuController)

import TaskListPickerController from "./task_list_picker_controller"
application.register("task-list-picker", TaskListPickerController)

import TaskCommentsController from "./task_comments_controller"
application.register("task-comments", TaskCommentsController)
import TaskAttachmentsController from "./task_attachments_controller"
application.register("task-attachments", TaskAttachmentsController)

import TaskPaneController from "./task_pane_controller"
application.register("task-pane", TaskPaneController)

import TaskPaneMenuController from "./task_pane_menu_controller"
application.register("task-pane-menu", TaskPaneMenuController)

import TaskSwipeController from "./task_swipe_controller"
application.register("task-swipe", TaskSwipeController)

import TasksBoardController from "./tasks_board_controller"
application.register("tasks-board", TasksBoardController)

import TasksMindmapController from "./tasks_mindmap_controller"
application.register("tasks-mindmap", TasksMindmapController)

import TasksGalaxyController from "./tasks_galaxy_controller"
application.register("tasks-galaxy", TasksGalaxyController)

import TasksOutlineController from "./tasks_outline_controller"
application.register("tasks-outline", TasksOutlineController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ThreadTriageController from "./thread_triage_controller"
application.register("thread-triage", ThreadTriageController)

import TimeZoneController from "./time_zone_controller"
application.register("time-zone", TimeZoneController)

import ToggleBadgeController from "./toggle_badge_controller"
application.register("toggle-badge", ToggleBadgeController)

import ToggleVisibilityController from "./toggle_visibility_controller"
application.register("toggle-visibility", ToggleVisibilityController)


import TreeEditLinkController from "./tree_edit_link_controller"
application.register("tree-edit-link", TreeEditLinkController)

import TypingHeartbeatController from "./typing_heartbeat_controller"
application.register("typing-heartbeat", TypingHeartbeatController)

import UniversalComposeController from "./universal_compose_controller"
application.register("universal-compose", UniversalComposeController)

import UniversalSearchController from "./universal_search_controller"
application.register("universal-search", UniversalSearchController)

import VideoRecorderController from "./video_recorder_controller"
application.register("video-recorder", VideoRecorderController)

import WatchPartyController from "./watch_party_controller"
application.register("watch-party", WatchPartyController)

import WeatherAppController from "./weather_app_controller"
application.register("weather-app", WeatherAppController)

import WeatherSceneController from "./weather_scene_controller"
application.register("weather-scene", WeatherSceneController)

import WebcamController from "./webcam_controller"
application.register("webcam", WebcamController)

import WhatsappConnectController from "./whatsapp_connect_controller"
application.register("whatsapp-connect", WhatsappConnectController)

import WireMapController from "./wire_map_controller"
application.register("wire-map", WireMapController)

import WireMiniMapController from "./wire_mini_map_controller"
application.register("wire-mini-map", WireMiniMapController)

import WireVideoController from "./wire_video_controller"
application.register("wire-video", WireVideoController)

import ZenAlarmController from "./zen_alarm_controller"
application.register("zen-alarm", ZenAlarmController)

import ZenSceneryController from "./zen_scenery_controller"
application.register("zen-scenery", ZenSceneryController)

import ZenSoundController from "./zen_sound_controller"
application.register("zen-sound", ZenSoundController)

import ZenTimerController from "./zen_timer_controller"
application.register("zen-timer", ZenTimerController)
import ZenTimerModalController from "./zen_timer_modal_controller"
application.register("zen-timer-modal", ZenTimerModalController)

import ProfileAutosaveController from "./profile_autosave_controller"
application.register("profile-autosave", ProfileAutosaveController)

import ProfileNavigationController from "./profile_navigation_controller"
application.register("profile-navigation", ProfileNavigationController)

import ProfileLinkIconController from "./profile_link_icon_controller"
application.register("profile-link-icon", ProfileLinkIconController)

import ProfileLocalTimeController from "./profile_local_time_controller"
application.register("profile-local-time", ProfileLocalTimeController)


import ProfileAskController from "./profile_ask_controller"
application.register("profile-ask", ProfileAskController)

import ProfileMessageRequestController from "./profile_message_request_controller"
application.register("profile-message-request", ProfileMessageRequestController)

import SchedulingNavController from "./scheduling_nav_controller"
application.register("scheduling-nav", SchedulingNavController)

import SchedulingPickerController from "./scheduling_picker_controller"
application.register("scheduling-picker", SchedulingPickerController)

import SchedulingRulesController from "./scheduling_rules_controller"
application.register("scheduling-rules", SchedulingRulesController)
import SchedulingPreviewController from "./scheduling_preview_controller"
application.register("scheduling-preview", SchedulingPreviewController)

import SchedulingHelpController from "./scheduling_help_controller"
application.register("scheduling-help", SchedulingHelpController)
import SchedulingTypeController from "./scheduling_type_controller"
application.register("scheduling-type", SchedulingTypeController)

import SchedulingCalendarsController from "./scheduling_calendars_controller"
application.register("scheduling-calendars", SchedulingCalendarsController)

import SchedulingHealthController from "./scheduling_health_controller"
application.register("scheduling-health", SchedulingHealthController)

import SchedulingScheduleController from "./scheduling_schedule_controller"
application.register("scheduling-schedule", SchedulingScheduleController)

import SchedulingVideoController from "./scheduling_video_controller"
application.register("scheduling-video", SchedulingVideoController)

import SchedulingEditorController from "./scheduling_editor_controller"
application.register("scheduling-editor", SchedulingEditorController)

import VoiceCallController from "./voice_call_controller"
application.register("voice-call", VoiceCallController)

import SchedulingDialogController from "./scheduling_dialog_controller"
application.register("scheduling-dialog", SchedulingDialogController)

import SchedulingShareController from "./scheduling_share_controller"
application.register("scheduling-share", SchedulingShareController)

import SchedulingCreateController from "./scheduling_create_controller"
application.register("scheduling-create", SchedulingCreateController)

import SchedulingRecipientController from "./scheduling_recipient_controller"
application.register("scheduling-recipient", SchedulingRecipientController)

import SignalTipController from "./signal_tip_controller"
application.register("signal-tip", SignalTipController)

import SignalExpandController from "./signal_expand_controller"
application.register("signal-expand", SignalExpandController)

import SchedulingPageController from "./scheduling_page_controller"
application.register("scheduling-page", SchedulingPageController)

import ChatPageController from "./chat_page_controller"
application.register("chat-page", ChatPageController)

import SidebarSectionController from "./sidebar_section_controller"
application.register("sidebar-section", SidebarSectionController)

import RailSearchController from "./rail_search_controller"
application.register("rail-search", RailSearchController)

import ProfileTopicController from "./profile_topic_controller"
application.register("profile-topic", ProfileTopicController)

import ProfileSettingsController from "./profile_settings_controller"
application.register("profile-settings", ProfileSettingsController)

import YouNavigationController from "./you_navigation_controller"
application.register("you-navigation", YouNavigationController)

import PageViewsController from "./page_views_controller"
application.register("page-views", PageViewsController)

import ComposerChoicesController from "./composer_choices_controller"
application.register("composer-choices", ComposerChoicesController)

import MessageCategoryController from "./message_category_controller"
application.register("message-category", MessageCategoryController)

import ComposerCommandsController from "./composer_commands_controller"
application.register("composer-commands", ComposerCommandsController)

import ComposerMenuController from "./composer_menu_controller"
application.register("composer-menu", ComposerMenuController)

import WorkTimerController from "./work_timer_controller"
application.register("work-timer", WorkTimerController)

import DocumentPanelController from "./document_panel_controller"
application.register("document-panel", DocumentPanelController)

import DocumentMenuController from "./document_menu_controller"
application.register("document-menu", DocumentMenuController)
import GridTabsController from "./grid_tabs_controller"
application.register("grid-tabs", GridTabsController)
import GridEditorController from "./grid_editor_controller"
application.register("grid-editor", GridEditorController)
import ProjectChatsController from "./project_chats_controller"
application.register("project-chats", ProjectChatsController)
import ProjectFilesController from "./project_files_controller"
application.register("project-files", ProjectFilesController)
import CadenceFieldsController from "./cadence_fields_controller"
application.register("cadence-fields", CadenceFieldsController)
import ChannelPickerController from "./channel_picker_controller"
application.register("channel-picker", ChannelPickerController)

import DocumentLiveController from "./document_live_controller"
application.register("document-live", DocumentLiveController)

import DocumentRichEditorController from "./document_rich_editor_controller"
application.register("document-rich-editor", DocumentRichEditorController)

import DocumentVersionsController from "./document_versions_controller"
application.register("document-versions", DocumentVersionsController)

import DocumentCommentsController from "./document_comments_controller"
application.register("document-comments", DocumentCommentsController)

import CalendarScrollController from "./calendar_scroll_controller"
application.register("calendar-scroll", CalendarScrollController)

import CalendarFitController from "./calendar_fit_controller"
application.register("calendar-fit", CalendarFitController)

import CalendarPopoverController from "./calendar_popover_controller"
application.register("calendar-popover", CalendarPopoverController)

import CalendarKeysController from "./calendar_keys_controller"
application.register("calendar-keys", CalendarKeysController)

import IdeaModalController from "./idea_modal_controller"
application.register("idea-modal", IdeaModalController)

import DashboardRailController from "./dashboard_rail_controller"
application.register("dashboard-rail", DashboardRailController)

import NegLevelController from "./neg_level_controller"
application.register("neg-level", NegLevelController)
import NegSheetsController from "./neg_sheets_controller"
application.register("neg-sheets", NegSheetsController)
import JobCardsController from "./job_cards_controller"
application.register("job-cards", JobCardsController)
import CalendarCardsController from "./calendar_cards_controller"
application.register("calendar-cards", CalendarCardsController)
import PinnedLayoutController from "./pinned_layout_controller"
application.register("pinned-layout", PinnedLayoutController)
import SideSectionController from "./side_section_controller"
application.register("side-section", SideSectionController)
import FlowCanvasController from "./flow_canvas_controller"
application.register("flow-canvas", FlowCanvasController)
import FlowEditController from "./flow_edit_controller"
application.register("flow-edit", FlowEditController)

import FeedActController from "./feed_act_controller"
application.register("feed-act", FeedActController)
import FlowMenuController from "./flow_menu_controller"
application.register("flow-menu", FlowMenuController)

import PlaidLinkController from "./plaid_link_controller"
application.register("plaid-link", PlaidLinkController)

import QuickActionOrderController from "./quick_action_order_controller"
application.register("quick-action-order", QuickActionOrderController)
import BlockPickerController from "./block_picker_controller"
application.register("block-picker", BlockPickerController)
import RunwayScenarioController from "./runway_scenario_controller"
application.register("runway-scenario", RunwayScenarioController)
